import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import useNotifier from "@saleor/hooks/useNotifier";
import { DialogProps } from "@saleor/types";
import {
  DeliveryTypeEnum,
  SmopOrderStatusEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";
import React from "react";
import { useIntl } from "react-intl";

import { StoreOrderDetails_storeOrder_lines } from "../../types/StoreOrderDetails";

const useStyles = makeStyles(
  {
    buttonConfirm: {
      backgroundColor: "#FFD15C !important",
      marginLeft: "8px"
    }
  },
  {
    name: "ConfirmationDialog"
  }
);
export interface StoreOrderConfirmationDialogProps extends DialogProps {
  orderStatus: string;
  handleSubmit: any;
  userType: string;
  isParcelIDValidated: boolean;
  deliveryType: string;
  hasPicking: boolean;
  hasOutOfStock: boolean;
  storeOrderLines: StoreOrderDetails_storeOrder_lines[];
}

const StoreOrderConfirmationDialog: React.FC<StoreOrderConfirmationDialogProps> = props => {
  const {
    onClose,
    open,
    orderStatus,
    handleSubmit,
    userType,
    isParcelIDValidated,
    deliveryType,
    // hasPicking,
    hasOutOfStock,
    storeOrderLines
  } = props;

  const classes = useStyles(props);
  const notify = useNotifier();
  const intl = useIntl();

  let dialogText = "";
  let newOrderStatus;

  switch (orderStatus) {
    case "NEW_ORDER":
      dialogText = "Are you sure you want to acknowledge this order?";
      newOrderStatus = SmopOrderStatusEnum.ACKNOWLEDGED;
      break;
    case "ACKNOWLEDGED":
      dialogText = "Are you sure you want to mark this order as Ready?";
      newOrderStatus = SmopOrderStatusEnum.READY;
      break;
    case "READY":
      if (deliveryType === DeliveryTypeEnum.IN_STORE_PICKUP) {
        dialogText = "Are you sure you want to mark this order as Completed?";
        newOrderStatus = SmopOrderStatusEnum.COMPLETED;
        break;
      }

      dialogText = "Are you sure you want to mark this order as Collected?";
      newOrderStatus = SmopOrderStatusEnum.COLLECTED;
      break;

    case "COLLECTED":
      dialogText =
        "Are you sure you want to mark this order as Received at FC?";
      newOrderStatus = SmopOrderStatusEnum.RECEIVED_AT_FC;
      break;
    case "RECEIVED_AT_FC":
      dialogText = "Are you sure you want to mark this order as Packed?";
      newOrderStatus = SmopOrderStatusEnum.PACKED;
      break;
    default:
      break;
  }

  const handleConfirmDialogSubmit = () => {
    if (
      orderStatus === "COLLECTED" &&
      userType === SmopUserTypeCode.OMI_OPS &&
      isParcelIDValidated === false &&
      (deliveryType === DeliveryTypeEnum.NEXT_DAY ||
        deliveryType === DeliveryTypeEnum.NATIONWIDE_DELIVERY)
    ) {
      notify({
        status: "error",
        text: intl.formatMessage({
          defaultMessage:
            "Unable to mark as Received at FC. Please validate the parcel ID first."
        })
      });
      onClose();
    } else if (storeOrderLines.length === 0) {
      notify({
        status: "error",
        text: intl.formatMessage({
          defaultMessage: "Unable to mark as ready. Please add product."
        })
      });
      onClose();
      // } else if (orderStatus === "ACKNOWLEDGED" && hasPicking) {
      //   notify({
      //     status: "error",
      //     text: intl.formatMessage({
      //       defaultMessage:
      //         "Unable to mark as ready. Please pick all the items first."
      //     })
      //   });
      //   onClose();
    } else if (orderStatus === "ACKNOWLEDGED" && hasOutOfStock) {
      notify({
        status: "error",
        text: intl.formatMessage({
          defaultMessage:
            "Unable to mark as ready due to out-of-stock item. Please remove the item first with consent of Customer."
        })
      });
      onClose();
    } else {
      handleSubmit({ status: newOrderStatus, type: "UPDATE_STATUS" });
      onClose();
    }
  };

  const confirmationDialog = () => (
    <Dialog onClose={onClose} open={open} maxWidth="xs" fullWidth>
      <>
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <div>
            <Button autoFocus onClick={onClose} color="secondary">
              Cancel
            </Button>
            <Button
              autoFocus
              onClick={handleConfirmDialogSubmit}
              color="primary"
              variant="contained"
              className={classes.buttonConfirm}
            >
              Confirm
            </Button>
          </div>
        </DialogActions>
      </>
    </Dialog>
  );
  return confirmationDialog();
};
StoreOrderConfirmationDialog.displayName = "StoreOrderConfirmationDialog";
export default StoreOrderConfirmationDialog;
